module.exports = __webpack_public_path__ + "static/media/decoracao.b16081e4.jpg";